import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ClassroomSummary = ({ classrooms, onManageClick }) => {
  return (
    <div className="bg-card rounded-lg shadow-sm overflow-hidden border-2 border-primary">
      <div className="p-4 md:p-5 lg:p-6 border-b border-primary/20 bg-primary/5">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary/15 rounded-lg flex items-center justify-center">
              <Icon name="Users" size={20} className="text-primary" />
            </div>
            <div>
              <h2 className="text-lg md:text-xl font-semibold text-foreground">Classrooms</h2>
              <p className="text-sm text-muted-foreground">{classrooms?.length} active classes</p>
            </div>
          </div>
          <Button
            variant="default"
            size="sm"
            iconName="Settings"
            onClick={onManageClick}
          >
            Manage
          </Button>
        </div>
      </div>
      <div className="p-4 md:p-5 lg:p-6">
        <div className="space-y-3">
          {classrooms?.length === 0 && (
            <div className="text-center py-4">
              <p className="text-sm text-muted-foreground">No classrooms yet.</p>
              <button
                onClick={onManageClick}
                className="mt-2 text-sm text-primary font-medium hover:underline"
              >
                Create a classroom
              </button>
            </div>
          )}
          {classrooms?.map((classroom) => (
            <div
              key={classroom?.id}
              className="bg-background rounded-lg p-4 hover-lift transition-organic cursor-pointer border border-border hover:border-primary/40"
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-base font-semibold text-foreground">{classroom?.name}</h3>
                <span className="px-2 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
                  {classroom?.studentCount} students
                </span>
              </div>

              <div className="grid grid-cols-3 gap-3 text-center">
                <div>
                  <p className="text-lg font-bold text-foreground">{classroom?.activeJourneys}</p>
                  <p className="text-xs text-muted-foreground">Journeys</p>
                </div>
                <div>
                  <p className="text-lg font-bold text-success">{classroom?.avgCompletion}%</p>
                  <p className="text-xs text-muted-foreground">Completion</p>
                </div>
                <div>
                  <p className="text-lg font-bold text-accent">{classroom?.activeStudents}</p>
                  <p className="text-xs text-muted-foreground">Active</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClassroomSummary;